export const testId = {
    articleComments: "article-comments",
    articleCommentsView: "article-comments-view",
    enableArticleCommentsInputMode: "enable-article-comments-input-mode",
    threadOpenButton: "thread-open-button"
} as const
